import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import moment from "moment";
import popup from './popup.css'
import DatePicker from "react-datepicker";
// import AgentService from "../services";
import { Breadcrumb, BreadcrumbItem, Card, CardBody, Button } from "reactstrap";
import { Link } from "react-router-dom";
import httpClient from "../../http-client/client";
import Popup from './Popup';
const columns = [
    {
        
        Header: "Title",
        accessor: "fcm_message_title", // String-based value accessors!
        Cell: props => (
           
          <span className="d-flex justify-content-center">
           
              {props.value}
          
         </span>
      
          
        )
      },
 
  {
    Header: "Sent ",
    accessor: "success_count", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header: "Failed ",
    accessor: "failed_count", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header: "Message Status ",
    accessor: "fcm_message_status", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">
      {props.value==false && "Failed"}
      {props.value==true && "Sent"}
      </span>
    )
  },

 
  
  {
    Header:"Message Datetime",
    accessor: "create_datetime", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center"> {moment(props.value).format('DD-MM-YYYY  LTS')}</span>
    )
  },

 
];

export default class FcmTable extends Component {
  

  state = {
  //  updateUserModal: false,
    rateId: "",
    productrateFordelete:'',
    productrateForUpdate:'',
    updateProductRates: false,
    deleteProductRatess: false,
    data:[],
    fcm_message_id: "",
    isOpen:false,
    datatoShare:[]
  
  };

  componentDidMount() {
this.getData();
  }
  
  toggle = async(id) => {
    console.log(id)
    let { data } =  await httpClient.get(`/refer/sendFcm/${id}`);
    this.setState(prevState => ({
        isOpen: !prevState.isOpen,fcm_message_id:id,datatoShare:data.response
    }));
  };
  closetoggle = async(id) => {
    console.log(id)
   // let { data } =  await httpClient.get(`/refer/sendFcm/${id}`);
    this.setState(prevState => ({
        isOpen: !prevState.isOpen,fcm_message_id:id,//datatoShare:data.response
    }));
  };
  showUpdateModal =  async function(id)  {
  
    await this.setState({rateId: id,productrateForUpdate:id }, () => {
    this.toggle();
    });
    console.log(this.state.rateId)
  };
  getData =async()=> {
    try {
        let { data } = await httpClient.get(`/refer/sendFcm`);
      
      
        
      console.log(data.response)
this.setState({data:data.response})
     
      } catch (error) {
       
      }
  }
  render() {
     let { data } = this.state;
     
     data.forEach(element => {
      // let urlid=`/dashboard/updateRates?${(element["rate_id"])}`;
      element["fcm_message_title"] = (
           <span>
    
          <Button
            onClick={() => {
              this.toggle(element["fcm_message_id"]);
            }}
            color="primary"
            className="m-1"
            // disabled={}
          >
            {element["fcm_message_title"]}
          </Button>
         
        </span>
      );
    });
    // data.forEach(element => {


    //   element["operation"] = (
    //     <span>
    //       <Button
            

    //         onClick={() => {
    //           this.showUpdateModal(element["user_id"]);
    //         }}
    //         color="primary"
    //         className="m-1"
    //         // disabled={}
    //       >
    //         <i className="fas fa-edit"></i>
    //       </Button>
        
    //     </span>
    //   );
    // });

    return (
      <div>
         
        <ReactTable
          data={this.state.data}
          columns={columns}
          showPaginationTop={true}
          showPaginationBottom={false}
        />
      
      {(this.state.isOpen) ? (
         
         <Popup            
         handleClose={this.closetoggle}
         data={this.state.datatoShare}
          />
          
        ) : null}
        
      </div>
    );
  }
}
